import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { saveAs } from 'file-saver';
import { SignoAuditoriaService } from '@services/auditoria/signo-auditoria.service';
import { SignoAuditoriaEvento } from '@interfaces/interface-bakend/auditoria/signo-auditoria-evento.interface';
import { AUDITORIA_COMPONENTES, iconoAccion, labelAccion, labelModulo, resumenPayload } from '../diccionario/auditoria-diccionario';
import { coincideFuzzy } from '@shared/utils/fuzzy-search.util';

@Component({
    selector: 'app-auditoria-listado',
    templateUrl: './auditoria-listado.component.html',
    styleUrls: ['./auditoria-listado.component.scss'],
})
export class AuditoriaListadoComponent implements OnInit {

    @ViewChild(MatSort) set matSort(ms: MatSort) {
        if (ms) { this.dataSource.sort = ms; }
    }
    @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
        if (mp) { this.dataSource.paginator = mp; }
    }

    displayedColumns: string[] = ['fecha', 'usuario', 'accion', 'resumen', 'resultado', 'acciones'];
    dataSource: MatTableDataSource<SignoAuditoriaEvento> = new MatTableDataSource();

    modulo: string = '';
    tituloComponente: string = 'Auditoría';
    flagLoaded: boolean = false;
    termino: string = '';

    labelAccion = labelAccion;
    iconoAccion = iconoAccion;
    resumenPayload = resumenPayload;

    constructor(
        private router: Router,
        private signoAuditoriaService: SignoAuditoriaService,
    ) {
        this.dataSource.filterPredicate = (data, filter) => {
            const texto = [
                data.usuario?.nombreCompleto,
                data.usuario?.email,
                labelAccion(data.accion),
                resumenPayload(data),
                data.resultado,
            ].join(' ');
            return coincideFuzzy(texto, filter);
        };
    }

    async ngOnInit(): Promise<void> {
        if (!(await this.signoAuditoriaService.puedeAccederAuditoria())) {
            this.signoAuditoriaService.setAccesoDenegado(true);
            this.router.navigateByUrl('/configurar-administracion');
            return;
        }
        this.modulo = this.signoAuditoriaService.getModuloSeleccionado();
        if (!this.modulo) {
            this.router.navigateByUrl('/menu-auditoria');
            return;
        }
        this.tituloComponente = AUDITORIA_COMPONENTES.find((c) => c.modulo === this.modulo)?.titulo || labelModulo(this.modulo);
        await this.cargarEventos();
    }

    private async cargarEventos(): Promise<void> {
        const eventos = await this.signoAuditoriaService.getEventosByModulo(this.modulo);
        this.dataSource.data = eventos;
        this.flagLoaded = true;
    }

    aplicarFiltro(termino: string): void {
        this.termino = termino;
        this.dataSource.filter = (termino || '').trim();
        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }

    verDetalle(evento: SignoAuditoriaEvento): void {
        this.signoAuditoriaService.setEventoSeleccionado(evento);
        this.router.navigateByUrl('/auditoria-detalle');
    }

    async exportarListado(): Promise<void> {
        const pag = this.dataSource.paginator;
        try {
            const blob = await this.signoAuditoriaService.exportarEventos({
                modulo: this.modulo,
                page: pag ? pag.pageIndex + 1 : 1,
                limit: pag ? pag.pageSize : 20,
            });
            const startIdx = pag ? pag.pageIndex * pag.pageSize : 0;
            const endIdx = pag ? startIdx + pag.pageSize : this.dataSource.filteredData.length;
            const pagina = this.dataSource.filteredData.slice(startIdx, endIdx);
            const fechaDesde = pagina.length ? this.formatearFecha(pagina[0].fecha) : '';
            const fechaHasta = pagina.length ? this.formatearFecha(pagina[pagina.length - 1].fecha) : '';
            const nombre = `Auditoria_${this.modulo}_${fechaDesde}_${fechaHasta}.xlsx`;
            saveAs(blob, nombre);
        } catch (err) {
            console.error('[Auditoria] Error al exportar:', err);
        }
    }

    private formatearFecha(iso: string): string {
        if (!iso) { return ''; }
        const partes = iso.substring(0, 10).split('-');
        return `${partes[2]}-${partes[1]}-${partes[0]}`;
    }

    volver(): void {
        this.router.navigateByUrl('/menu-auditoria');
    }
}
